(function () {
  var section = document.querySelector('.compare-to-category');
  if (!section) return;

  var cells = section.querySelectorAll('.cell.product-col[data-col]');

  function highlight(col, on) {
    section
      .querySelectorAll('.cell.product-col[data-col="' + col + '"]')
      .forEach(function (el) {
        el.classList.toggle('is-col-hover', on);
      });
  }

  cells.forEach(function (cell) {
    var col = cell.getAttribute('data-col');

    cell.addEventListener('mouseenter', function () {
      highlight(col, true);
    });

    cell.addEventListener('mouseleave', function () {
      highlight(col, false);
    });
  });
})();
